import type { ReactElement } from 'react';
import React, { useState } from 'react';
import {
  Modal,
  DatePicker,
  Button,
  View,
  FormSection,
  FormRow,
  FormField,
} from '../ui';
import moment from 'moment';

export type SelectCompletedModalProps = {
  onClose: () => void;
  onSelectCompletedBeforeDate?: (date: Date) => void;
};

const SelectCompletedModal = ({
  onClose,
  onSelectCompletedBeforeDate,
}: SelectCompletedModalProps): ReactElement => {
  const [date, setDate] = useState<Date>(moment().add(-14, 'day').toDate());

  return (
    <Modal
      isOpen
      onClose={onClose}
      viewProps={{
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <View backgroundColor="white" width={340}>
        <FormSection borderBottomStyle="none" alignItems="center">
          <FormRow>
            <FormField label="Completed before date:" width={300}>
              <DatePicker
                timeZone="UTC"
                selected={date}
                showTime={false}
                onChange={(date: Date) => setDate(date)}
              />
            </FormField>
          </FormRow>
          <FormRow>
            <Button
              onPress={() => {
                onSelectCompletedBeforeDate?.(date);
                onClose();
              }}
            >
              Select all completed before date
            </Button>
            <Button onPress={onClose}>Cancel</Button>
          </FormRow>
        </FormSection>
      </View>
    </Modal>
  );
};

export default SelectCompletedModal;
